// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./app/assets/styles/components/session-groups.scss
// module id = 107
// module chunks = 1